/*
 * @Description: 积分商城店铺管理接口相关接口
 * @Author: guqiang
 * @Date: 2021-10-13 17:40:23
 * @LastEditors: guqiang
 * @LastEditTime: 2021-10-13 18:09:34
 */
import request from './request';

/**
 * @description: 商店列表
 * @param {*} body http://yapi.iklicen.com/project/139/interface/api/436055
 * @return {*}
 */
export function getShopList(params) {
    return request('/mall/shop/list', {
        method: 'GET',
        params,
    });
}

/**
 * @description: 当前用户下的所有商店
 * @param {*} body http://yapi.iklicen.com/project/139/interface/api/436055
 * @return {*}
 */
export function getShopsOfUser(params) {
    return request('/mall/shop/list-all', {
        method: 'GET',
        params,
    });
}

/**
 * @description: 创建商店
 * @param {*} body http://yapi.iklicen.com/project/139/interface/api/436056
 * @return {*}
 */
export function createShop(params) {
    return request('/mall/shop', {
        method: 'POST',
        params,
    });
}

/**
 * @description: 校验是否重复开通商店
 * @param {*} body http://yapi.iklicen.com/project/139/interface/api/436056
 * @return {*}
 */
export function checkRepeatCreate(params) {
    return request('/mall/shop/check', {
        method: 'POST',
        params,
    });
}

/**
 * @description: 获取全部商品
 * @param {*} body http://yapi.iklicen.com/project/139/interface/api/436056
 * @return {*}
 */
export function allGoods(params) {
    return request('/mall/goods-spu/list', {
        method: 'POST',
        params,
    });
}

/**
 * @description: 店铺装修查询
 * @param {*} body http://yapi.iklicen.com/project/139/interface/api/436056
 * @return {*}
 */
export function deviseDetail(params) {
    return request('/mall/page-devise', {
        method: 'GET',
        params,
    });
}

/**
 * @description: 店铺装修保存
 * @param {*} body http://yapi.iklicen.com/project/139/interface/api/436056
 * @return {*}
 */
export function deviseSave(params) {
    return request('/mall/page-devise', {
        method: 'PUT',
        params,
    });
}

/**
 * @description: 创建商店校验
 * @param {*} body http://yapi.iklicen.com/project/139/interface/api/436056
 * @return {*}
 */
export function beforeCreatecheck(tenantId) {
    return request(`/mall/tenant/check/${tenantId}`, {
        method: 'GET',
    });
}
